export enum StatusCode {
    UnknownError = 0,
    Unauthorized = 401,
    BadRequest = 400,
    Forbidden = 403,
    NotFound = 404,
    UserDefinedException = 499,
    InternalServerError = 500,
}